export const COST_CATEGORIES_BASE_QUERY_KEY = 'cost-categories';

export const costCategoriesApiQueryKeys = {
  all: () => [COST_CATEGORIES_BASE_QUERY_KEY] as const,
  list: (archived?: boolean) =>
    [COST_CATEGORIES_BASE_QUERY_KEY, { archived }] as const,
  usage: (id: string) => [COST_CATEGORIES_BASE_QUERY_KEY, id, 'usage'] as const,
};
